import { Link } from 'react-router-dom';
import { FaInstagram, FaTiktok } from 'react-icons/fa';

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg bg-light px-4">
      <div className="container-fluid">
        <Link className="navbar-brand fw-bold style={{ color: '#E4405F' }}" to="/">Habibtea</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-between" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/our-story">Our Story</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/menu">Menu</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/book-now">Book Now</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/gallery">Gallery</Link></li>
          </ul>
          <div className="d-flex gap-3 align-items-center">
            <a href="https://www.instagram.com/habibteachi/" target="_blank" rel="noreferrer">
              <FaInstagram style={{ color: '#E4405F' }} />
            </a>
            <a href="https://www.tiktok.com/@habibteachi?_r=1&_t=ZP-978HI8SF970" target="_blank" rel="noreferrer">
              <FaTiktok style={{ color: '#010101' }} />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
